import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const CAPELogo = props => (
  <StaticImage
    className="center"
    style={
      props.sm
        ? { width: "30px" }
        : props.md
        ? { width: "50px" }
        : props.lg
        ? { width: "70px" }
        : { width: "90px" }
    }
    src={"../images/cape.png"}
    alt="CAPE logo"
  />
)

export default CAPELogo
